import { render, staticRenderFns } from "./CandidatesEmailTemplates.vue?vue&type=template&id=a94c25ba&scoped=true&lang=pug"
import script from "./CandidatesEmailTemplates.vue?vue&type=script&lang=js"
export * from "./CandidatesEmailTemplates.vue?vue&type=script&lang=js"
import style0 from "./CandidatesEmailTemplates.vue?vue&type=style&index=0&id=a94c25ba&prod&lang=scss&scoped=true"
import style1 from "./CandidatesEmailTemplates.vue?vue&type=style&index=1&id=a94c25ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c25ba",
  null
  
)

export default component.exports